import * as events from "../events/library/libraryEvents";
import {
  createDraftSuccess,
  publishSuccess,
  revertSuccess,
  successAction,
  updateSuccess,
} from "features/Library/ExternalLinks/state/ExternalLinkEntityStateSlice";
import * as backgroundTasksActions from "../../../../BackgroundTasks/state/backgroundTasksActions";
import {
  updateFailedTaskDistributedOperation,
  updateSucceededTaskDistributedOperation,
} from "../../../../BackgroundTasks/state/backgroundTasksActions";
import { createDispatcher } from "../dispatcher";
import { type IMapping } from "./types";
import { type Dispatcher, type MidnightActionPayload } from "interfaces";

export const externalLinkMapping = (mapping: IMapping, dispatcher: Dispatcher) => {
  const {
    dispatch,
    dispatchPublishSuccess,
    dispatchBatchOperationSuccess,
    dispatchBatchOperationFailure,
    dispatchMap,
  } = createDispatcher(dispatcher);

  mapping[events.LinkPublishSuccess] = dispatchPublishSuccess<{ id: number; message: string }>(
    publishSuccess,
    (data) => data.message,
  );

  mapping[events.LinkDiscardSuccess] = dispatch(revertSuccess);
  mapping[events.LinkLockSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(
    createDraftSuccess,
    (message) => ({ entityId: message.id }),
  );
  mapping[events.LinkEditSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(updateSuccess, (message) => ({
    entityId: message.id,
  }));
  mapping[events.LinkUpdateCommandCompleted] = dispatch(successAction);

  mapping[events.LinkTagsAddSuccess] = dispatchBatchOperationSuccess;
  mapping[events.LinkTagsAddFailure] = dispatchBatchOperationFailure;
  mapping[events.LinkTagsEditSuccess] = dispatch(successAction);

  mapping[events.LinkDeletionSuccess] = (payload) =>
    dispatcher(backgroundTasksActions.updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));
  mapping[events.LinkDeletionFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.DeleteAllLinkSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.DeleteAllLinkFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.LinkDuplicateSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.LinkDuplicateFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.DuplicateAllLinkSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.DuplicateAllLinkFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.LinkEditVisibilityAllSuccess] = (payload) =>
    dispatcher(backgroundTasksActions.updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));
  mapping[events.LinkEditVisibilityAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.LinkEditVisibilityAllSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.LinkEditVisibilityAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
};
